import { getIsNotiAllowed } from '@/utils/fetchers/notification'
import { useCallback } from 'react'
import { JIKE_WEB_HOST } from '../request/host'

export function useUnreadNotifier() {
	return useCallback((unreadCount: number) => {
		const isAllowed = getIsNotiAllowed()
		if (!isAllowed) {
			return
		}

		const notification = new Notification(`${unreadCount}条新互动`, {
			icon: 'https://m.okjike.com/favicon-32x32.png',
		})
		notification.onclick = () => {
			window.open(`${JIKE_WEB_HOST}/notification`, '_blank')
		}
	}, [])
}
